module.exports = __webpack_public_path__ + "static/media/illustration-mural-noticia.d6895c1e.svg";